import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import * as UTIL from "../../util";
import { DesktopTitleCardList } from "../card";
import Wrapper from '../wrapper/Wrapper';
import { Link } from "@sitecore-jss/sitecore-jss-react";
import { promoImpressionsGA } from "../../util/ga-analytics/ecomm/checkout";
export var RetailSelectedProducts = function RetailSelectedProducts(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$layout = props.layout,
      proplayout = _props$layout === void 0 ? {} : _props$layout;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? {} : _fields$items;
  var heading = items.heading,
      _items$products = items.products,
      products = _items$products === void 0 ? [] : _items$products,
      cardDisplayType = items.cardDisplayType,
      totalCardsInRow = items.totalCardsInRow,
      background = items.background,
      padding = items.padding,
      link = items.link;
  var cards = Array.isArray(products) ? products.map(function (product) {
    return {
      fields: UTIL.mapProductRetail(UTIL.toPascal(product), true, true)
    };
  }) : [];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasLoadedOnce = _useState2[0],
      setHasLoadedOnce = _useState2[1];

  var layout = _objectSpread({
    background: background || 'solid',
    padding: padding || 'medium'
  }, proplayout); // get promoImpressions for the Carousel items and check to prevent duplicate data being sent to gtm/ga


  if ((products === null || products === void 0 ? void 0 : products.length) > 0 && !hasLoadedOnce) {
    promoImpressionsGA(products);
  }

  useEffect(function () {
    if (!hasLoadedOnce) {
      setHasLoadedOnce(true);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-retail__selected-products"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(DesktopTitleCardList, _extends({}, props, {
    title: {
      value: heading
    },
    layout: layout,
    cards: cards,
    cardDisplayType: cardDisplayType ? cardDisplayType : "carousel",
    totalCardsInRow: totalCardsInRow ? totalCardsInRow : "3"
  }), Boolean(link === null || link === void 0 ? void 0 : link.href) && /*#__PURE__*/React.createElement("div", {
    className: "text-center w-100"
  }, /*#__PURE__*/React.createElement("a", {
    href: link.href,
    title: link.title
  }, "View all")))));
};